import React from "react"
import { graphql, useStaticQuery } from "gatsby"

import Seo from "../components/seo"
import HeaderLayout from "../components/headerLayout"
import Img from "gatsby-image"
import Stats from "../components/stats"


import StyledTextSectionClean from "../components/textSectionClean"

const Utrulling = () => {
  const data = useStaticQuery(graphql`
    query {
      bilde1: file(relativePath: { eq: "utrulling_bilde1.jpg" }) {
        childImageSharp {
          fixed(width: 600, quality: 100) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
      bilde2: file(relativePath: { eq: "utrulling_bilde2.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 517, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <>
      <Seo title="Utrulling" />
      <HeaderLayout />
      <StyledTextSectionClean
        fullWidth
        id="pilot"
        header="UTRULLING 2018 → 2019 → 2020 → 2021"
      >
        <p>
          Målet for utrulling var å nå flest mulig kommuner og skoler i Norge
          med læremiddelet, slik at flest mulig tok det i bruk. Mange skoler
          valgte å ta imot tilbudet om en introduksjonsopplæring på to
          skoletimer, mens andre tok i bruk læremiddelet uten videre oppfølging.
        </p>
        <p>
          Budskapet i introduksjonsopplæringen har vært å formidle hvordan
          læremiddelet er bygd opp, og at det er enkelt å bruke for læreren uten
          videre forutsetninger eller opplæring i førstehjelp. Vi har lagt vekt
          på å formidle at førstehjelp kan tas inn i flere av de tverrfaglige
          temaene, blant annet folkehelse og livsmestring, og demokrati og
          medborgerskap.{" "}
        </p>
        <p>
        Vi gjennomførte opplæring på 187 skoler fordelt rundt i alle fylkene i Norge frem til mars 2020. I tillegg har vi per 01.06.21 registrert 57 372 økter og 27 524 brukere av læremiddelet.
        </p>
        <Img to="Img" fixed={data.bilde1.childImageSharp.fixed} />
      </StyledTextSectionClean>
      <StyledTextSectionClean
        fullWidth
        id="pilot"
        header="SUKSESSFAKTORER"
      >
        <p>
        Gjennom utrullingsperioden har vi møtt mange skoleledere og lærere. Gratis introduksjonskurs har vært avgjørende for å sette skolene i gang med førstehjelpsundervisningen og spre kunnskap om at læremiddelet finnes. Mottakelsen har vært utelukkende positiv på kurs, og mange lærere har satt pris på at læremiddelet inneholder alt de trenger og er klart til bruk.
        </p>
        <i className="italic"> «Så enkelt, men viktig. Jeg vil som leder sikre at våre lærere og elever blir gode livreddere» - rektor ved Baksalen skole i Finnmark.</i>
        <p>
        Å ta med lærerne inn i prosessen ved utvikling av innholdet er også en avgjørende faktor for at lærere kjenner igjen innholdets oppbygning. Terskelen må være lav for å ta det i bruk, og den senkes ved at læreren har alt den trenger på et sted.
        </p>
        <p>
        Fortvilelsen over å miste dyrebar tid med lærere høsten 2020, da covid-19 pandemien traff oss, var stor. En fullbooket vår med introduksjonsopplæring ble avlyst og innspurten til prosjektperioden nærmet seg. Derfor kan vi med glede se på tallene for mars, april og mai 2020, og se at lærerne har det de trenger, og de kan fint ta dette i bruk på egenhånd! Antall besøkende og økter øker stabilt, til tross for at vi ikke har vært til stede på skoler i like stor grad som tidligere. Dette indikerer at læremiddelet står godt for seg selv.
        </p>
        <p>Digitale kurs har også vært gjennomført for tre kommuner i perioden med covid-19, med gode tilbakemeldinger:</p>
        <i className="italic">«Dette tema er LÆRING FOR LIVET for våre elever. Dette tenker jeg bør - les skal - være et årlig fastsatt tema der alle trinn skal gjennomgå førstehjelp. Kurset ble flyttet fra Helsfyr og gjennomført digitalt. Dette kurset var et av de aller beste kurs jeg deltatt på, på lang tid. I Kunnskapsløftet ligger det på alle syv trinn læringsmål knyttet til bland annet livsmestring som direkte kan knyttes til førstehjelp.» - lærer ved Nordstrand skole i Oslo.</i>
        <p>Videre leser dere mer om hvilke valg vi har tatt som har hjulpet oss på veien til et aktivt brukt læremiddel i førstehjelp.</p>
      </StyledTextSectionClean>
      <StyledTextSectionClean fullWidth>
        <h2>DIGITAL LÆRINGSPLATTFORM</h2>
        <p>
          En viktig forutsetning for delprosjektene i den nasjonale dugnaden,
          sammen redder vi liv, var at de løsninger som ble utviklet baserte seg
          på et kunnskapsgrunnlag. Alt skulle være gratis for målgruppene og
          distribuert gjennom nye og innovative teknologiløsninger.{" "}
        </p>
        <p>
          Design container er et designbyrå som laget og distribuerte den første
          nettsiden til prosjektets læremiddel. De utviklet en designprofil
          gjennom et utvalg av karakterer og animasjonsfilmer til første fase av
          pilot (2017-2018).{" "}
        </p>
        <p>
          Basert på evaluering for pilotperioden ble det besluttet å overføre
          læremiddelet til TV 2 Skole sin læringsportal, Elevkanalen.{" "}
        </p>
        <p>
          Læremiddelet førstehjelp ble nå knyttet opp mot kompetansemål i
          læreplanene fra Utdanningsdirektoratet, både fra Kunnskapsløftet og
          LK20 når disse kom. Vårt innhold ligger åpent tilgjengelig for alle,
          men en kan også velge Feide-innlogging. Feide er den nasjonale løsningen for sikker innlogging og datadeling i utdanning og forskning. Alle filmer er tekstet og
          oversatt til flere språk som engelsk, somali, arabisk, tigrinja,
          nynorsk og samisk. Løsningen har gitt oss mulighet for å tilpasse
          faktaopplysninger, bilder, e-bøker, filmer og nyheter som møter både
          eleven og læreren på en god måte.{" "}
        </p>
        <div className="stats_width">
        <Stats/>
        <span className="iframe-desc">Naviger i kartet for å se opplæring i skoler, kommuner og fylker i utrullingsperioden</span>
        </div>
      </StyledTextSectionClean>
      <StyledTextSectionClean fullWidth>
        <h2>INTRODUKSJONSOPPLÆRING</h2>
        <p>
          I Norge er det 636 350 elever fordelt på 2830 grunnskoler. Arbeidet
          med å kommunisere ut informasjon om læremiddelet er gjort gjennom
          ulike kanaler og møtepunkter. I hovedsak har vi kontaktet kommunenes
          overordnede ledelse (ordfører, rådmenn), skoleeiere, skolesjefer,
          lærere og rådgivere for oppvekst og utdanning.
        </p>
        <p>
          Kommunene og skolene har gjennom henvendelsene fått tilbud om 2-3
          timers gratis introduksjonsopplæring gjennomført av prosjektet. I
          hovedsak har vi fokusert på hvordan læreren kan benytte seg av
          læremiddelet i flere fag. Spesielt med hensyn på LK20, som trer i
          kraft i august 2020, har det vært viktig å vise hvordan dette er
          relevant for de nye kjerneelementene og tverrfaglige temaene.{" "}
        </p>
        <p>
          Flere av skolene forteller at de bruker læremiddelet ved oppstart av
          skoleåret . De bruker det også ved felles uteaktiviteter,
          prosjektoppgaver, uteskole, i stedet for en lesekvart på morgenen og
          ved ulike aktivitetsdager med mer.{" "}
        </p>
        <strong>Målene</strong>
        <p>
          Hovedmålet for introduksjonsopplæringen har vært å introdusere et nytt
          læremiddel utviklet for lærere til bruk i alle skoletrinn.{" "}
        </p>
        <p>Delmålene har vært å formidle at:</p>
        <ul>
          <li>Førstehjelp passer inn i mange fag</li>
          <li>Enkelt å lære bort</li>
          <li>
            Det er konkret og består av et rikholdig utvalg av læringsressurser
          </li>
          <li>Små drypp gjennom alle skoletrinn gir trygghet i å redder liv</li>
        </ul>
        <p>
          Vi har reist rundt på skoler og samlet alle lærerne, gitt tilbud om
          påmeldingskurs i Oslo kommune, og fått skolene i samme område til å
          samle seg til felles introduksjon.{" "}
        </p>
        <strong>Introduksjonsopplæringen har omfattet:</strong>
        <ul>
          <li>Nettsidens oppbygning</li>
          <li>
            Gjennomgang av temaene (oppbygning og struktur) opp mot
            kompetansemål
          </li>
          <li>
            Hvordan gjennomføre et tema i klasserommet. Praktisere øvelser (BLÅ,
            sideleie, ta av hjelm, hjerte- og lungeredning)
          </li>
          <li>
            Tips og råd på hvordan lærerne kan bruke læremiddelet i
            undervisningen på ulike måter
          </li>
        </ul>
        <p>
          I arbeidet med å nå ut til flest skoler i Norge har prosjektet valgt å
          samarbeide med andre ideelle organisasjoner/lag; Drive for life, Trygg
          trafikk og Friluftsråd om introduksjonsopplæringen. Disse har allerede
          etablert relasjoner og gjennomfører ulike opplæringstilbud opp mot
          skolene. Samtlige samarbeidspartnere har brukt samme mal for
          introduksjonsopplæringen.
        </p>
        <Img to="img" fluid={data.bilde2.childImageSharp.fluid} />
        <iframe
          title="gogole maps"
          src="https://www.google.com/maps/d/embed?mid=1eRBJ6tKfnxDYtRvfjY0oAXK7JmiJJq7E"
          width="640"
          height="480"
        ></iframe>
                <span className="iframe-desc">Naviger i kartet for å se opplæring i skoler, kommuner og fylker i utrullingsperioden</span>

      </StyledTextSectionClean>
      <StyledTextSectionClean fullWidth>
        <h2>DIGITAL INTRODUKSJON</h2>
        <p>
          I neste fase av utrullingen har vi laget en film for å redusere
          reisevirksomheten. Det er viktig at læremiddelet kan stå på egne ben,
          men samtidig er det mange som har nytte av informasjon om hvordan
          opplæringen med elevene er tenkt gjennomført. Ved å se denne filmen
          får lærerne informasjon om hvordan de skal kunne ta i bruk dette
          læremiddelet både teoretisk og i praksis.
        </p>
        <video
          controls
          poster="https://content.jwplatform.com/thumbs/ecy0TUKp-1920.jpg"
        >
          <source
            src="https://content.jwplatform.com/videos/ecy0TUKp-r2ztjrz9.mp4"
            type="video/mp4"
          ></source>
        </video>
      </StyledTextSectionClean>
    </>
  )
}

export default Utrulling
